;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVirtualIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 35
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "virtualIcon_svg__a",
  width: 35,
  height: 35,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h35v35H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#virtualIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5 30.625q-2.406 0-4.12-1.713t-1.713-4.12 1.713-4.12 4.12-1.714 4.12 1.714 1.713 4.12-1.713 4.12-4.12 1.713m0-2.917q1.203 0 2.06-.856a2.8 2.8 0 0 0 .857-2.06q0-1.203-.857-2.06a2.8 2.8 0 0 0-2.06-.857q-1.203 0-2.06.857a2.8 2.8 0 0 0-.857 2.06q0 1.203.857 2.06a2.8 2.8 0 0 0 2.06.856M4.448 12.542l-2.151-2.005Q5.25 7.657 9.15 6.016q3.9-1.641 8.349-1.641 4.447 0 8.349 1.64 3.9 1.64 6.854 4.522l-2.15 2.005a19.7 19.7 0 0 0-5.907-3.847Q21.328 7.292 17.5 7.292t-7.146 1.403a19.7 19.7 0 0 0-5.906 3.847m20.781 4.995a11.5 11.5 0 0 0-3.5-2.17q-1.968-.784-4.229-.784-2.26 0-4.21.784a12.1 12.1 0 0 0-3.52 2.17L7.62 15.53a14.6 14.6 0 0 1 4.502-2.844q2.535-1.02 5.378-1.02t5.36 1.02a14.7 14.7 0 0 1 4.484 2.844z"
}))));
export default SvgVirtualIcon;